import React from 'react';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsSimpleTable from 'ui-elements/tables/FsSimpleTable';
import useTheme from '@material-ui/core/styles/useTheme';
import { Fade, useMediaQuery } from '@material-ui/core';
import reportLocales from 'globals/locales/report';
import { FsComponentSize } from 'globals/types';
import { observer } from 'mobx-react';
import { useReportContext } from 'contexts/report/ReportContext';
import { isSuccessState } from 'globals/utils';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { getHelperTooltipContent } from 'ui-elements/modals/FsDefaultDialog/FsDefaultDialog.utils';
import { getFsPaperStyle } from './Events.style';

// Locales
const { title, tooltipInfo } = reportLocales.events;

const Events: React.FC = () => {
  const theme = useTheme();
  const isUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const {
    report: {
      events: { status, rows },
    },
  } = useReportContext();
  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );
  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <FsPaper
        title={title}
        tooltipContent={getHelperTooltipContent(tooltipInfo)}
        style={getFsPaperStyle(isUpMd)}
        data-test="events-component"
      >
        <FsSimpleTable rows={rows} rowSize={FsComponentSize.L} />
      </FsPaper>
    </Fade>
  );
};

export default observer(Events);
